import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../core/store';
import { EProductReservationTabs } from '../../types';
import * as settings from './settings';
import { useLocation } from 'react-router-dom';

const useSettings = () => {
    const dispatch = useDispatch();
    const appLink = useAppSelector(settings.selectors.getAppLink);

    const { pathname } = useLocation();
    const tab = getTab(pathname, appLink);

    const changeTab = useCallback(
        (tab: EProductReservationTabs) => {
            dispatch(settings.actions.setCurrentTab(tab));
        },
        [dispatch],
    );

    const setAppLink = useCallback(
        (appLink: string) => {
            dispatch(settings.actions.setAppLink(appLink));
        },
        [dispatch],
    );

    useEffect(() => {
        changeTab(tab as unknown as EProductReservationTabs);
    }, [pathname, changeTab, tab]);

    return {
        appLink: appLink,
        currentTab: tab,
        changeTab,
        setAppLink,
    };
};

export default useSettings;

const getTab = (link: string, appLink: string) => {
    const names = link.split('/');

    if (names[1] === appLink) {
        return names[2];
    }

    return "configuration-placeholder";
};
